module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/ico_gradient/aurora-ico-gradient-5a0ce786ac818cc696fae81f25a432ae.svg";